module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.generateLoading) ? _c('v-progress-linear', {
    staticClass: "loading",
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), (!_vm.generate) ? _c('v-form', {
    staticClass: "pt-3",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.header.licenseType,
      "items": _vm.types,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingLicenseType)); }],
      "required": ""
    },
    model: {
      value: (_vm.licenseType),
      callback: function($$v) {
        _vm.licenseType = $$v
      },
      expression: "licenseType"
    }
  })], 1), _vm._v(" "), (_vm.licenseType === 'daily') ? [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "return-value": _vm.fromDate,
      "lazy": "",
      "transition": "scale-transition",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.fromDate = $event
      },
      "update:return-value": function($event) {
        _vm.fromDate = $event
      }
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.$lang.labels.fromDate,
      "prepend-icon": "event",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingFromDate)); }],
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "primary",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu.save(_vm.fromDate)
      }
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    ref: "menu2",
    attrs: {
      "return-value": _vm.toDate,
      "lazy": "",
      "transition": "scale-transition",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.toDate = $event
      },
      "update:return-value": function($event) {
        _vm.toDate = $event
      }
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.$lang.labels.toDate,
      "prepend-icon": "event",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingToDate)); }],
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "primary",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu2.save(_vm.toDate)
      }
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "min-w max-w mx-2 mb-4",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.companies,
      "loading": _vm.companyLoading,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.licenseType === 'monthly' || _vm.licenseType === 'monthlyaggregated') ? [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.years,
      "label": _vm.$lang.actions.selectYear,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingYear)); }]
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.months,
      "label": _vm.$lang.actions.selectMonth,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMonth)); }]
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  })], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-4 pb-3",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('div', [_c('v-btn', {
    staticClass: "primary ml-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.showReports
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showReports))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    on: {
      "click": function($event) {
        return _vm.showGenerate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.generateMonthly))])], 1), _vm._v(" "), (_vm.reports.length !== 0) ? _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.generate) ? _c('v-form', {
    staticClass: "pt-3",
    model: {
      value: (_vm.generateValid),
      callback: function($$v) {
        _vm.generateValid = $$v
      },
      expression: "generateValid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.years,
      "label": _vm.$lang.actions.selectYear,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingYear)); }]
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.months,
      "label": _vm.$lang.actions.selectMonth,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMonth)); }]
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pb-4",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-4",
    attrs: {
      "disabled": !_vm.generateValid || _vm.generateLoading
    },
    on: {
      "click": function($event) {
        return _vm.generateReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.generate))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-4",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.close))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.show && !_vm.generate) ? _c('v-data-table', {
    attrs: {
      "headers": (_vm.licenseType === 'monthlyaggregated' ? _vm.aggrHeaders : _vm.headers),
      "items": _vm.reports,
      "search": _vm.search,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(_vm.licenseType !== 'monthlyaggregated') ? _c('td', [_vm._v(_vm._s(props.item.companyName))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), (_vm.licenseType === 'monthlyaggregated') ? _c('td', [_vm._v(_vm._s(props.item.year))]) : _vm._e(), _vm._v(" "), (_vm.licenseType === 'monthlyaggregated') ? _c('td', [_vm._v(_vm._s(_vm.months[parseInt(props.item.month, 10) - 1].text))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.viewLicense(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.view) + "\n          ")])], 1)]
      }
    }], null, false, 239183871)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "type": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.licenseReportDetailsModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1880"
    },
    model: {
      value: (_vm.licenseReportDetailsModal),
      callback: function($$v) {
        _vm.licenseReportDetailsModal = $$v
      },
      expression: "licenseReportDetailsModal"
    }
  }, [_c('license-report-details-modal', {
    attrs: {
      "licenseReportDetails": _vm.licenseReportDetails
    },
    on: {
      "close": function($event) {
        _vm.licenseReportDetailsModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0864b01c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/licenses/LicenseReports.vue
// module id = 381
// module chunks = 35